import { post } from "../utilities/ajax";

export default class StreamitInvoice {
    constructor() {
        this.setupEventHandlers();
    }

    setupEventHandlers() {
        jQuery(document).on('click', '.streamit-download-invoice', this.handleDownloadClick.bind(this));
    }

    handleDownloadClick(e) {
        e.preventDefault();
        const button = jQuery(e.currentTarget);
        const orderId = button.data('order-id');

        if (!orderId) {
            return;
        }

        button.prop('disabled', true);
        const originalText = button.text();
        button.text('Downloading...');

        // Include nonce in the POST request
        const nonce = button.data('nonce') || window.streamit_nonce || ''; 
        post('st_download_invoice', { order_id: orderId, nonce: nonce })
            .then(response => {

                if (!response.success) {
                    button.prop('disabled', false);
                    button.text(originalText);
                    return;
                }

                const { pdf_base64, filename, content_type } = response.data;

                if (content_type !== 'application/pdf') {
                    button.prop('disabled', false);
                    button.text(originalText);
                    return;
                }

                // Convert base64 to blob
                const byteCharacters = atob(pdf_base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                // Create download link
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename || 'invoice.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);

                setTimeout(() => {
                    button.prop('disabled', false);
                    button.text(originalText);
                }, 1000);
            })
            .catch(err => {
                setTimeout(() => {
                    button.prop('disabled', false);
                    button.text(originalText);
                }, 1000);
            });
    }
}